import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import {
  components as DefaultSelectComponents,
  SingleValueProps,
} from 'react-select';
import { Sector } from 'graphql-common';
import { SelectOption } from '@lib/components/Select/types';
import SectorChip from '@lib/components/SectorChip/SectorChip';
import { Option } from '@lib/interfaces/form';
import styles from '../Select.module.scss';

function SectorSingleValue({
  children,
  ...restProps
}: SingleValueProps): React.ReactElement {
  const { options } = restProps;
  const isDisabled = _get(restProps, 'selectProps.isDisabled');
  let option = _get(restProps, 'selectProps.value') as Option;
  if (!option?.value || !option?.label) {
    const value = _get(restProps, 'selectProps.value.value', '');
    const selectedOption = _find(
      options,
      ({ value: optionValue }) => value === optionValue,
    ) as SelectOption;
    if (selectedOption) option = selectedOption;
  }
  const sector = (_get(option, 'data') as Sector) ?? {
    name: _get(option, 'label'),
    color: _get(option, 'color'),
  };
  return (
    // @ts-ignore
    <DefaultSelectComponents.SingleValue
      {...restProps}
      className={styles.singleValue}
    >
      <div className={styles.singleValueBox}>
        <SectorChip sector={sector} disabled={isDisabled} />
      </div>
    </DefaultSelectComponents.SingleValue>
  );
}

export default SectorSingleValue;
